import { useState, useCallback } from 'react';

function useFieldValue(onValueChange) {
    const [value, setValue] = useState(undefined);
    const handleSetValue = useCallback((newValue, isOnInitialization, params) => {
        setValue(newValue);
        onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(newValue, isOnInitialization, params);
    }, [onValueChange]);
    return [value, handleSetValue];
}

export { useFieldValue as default };
